(function () {
  const numberValue = (card, name) => Number(card.getAttribute(name) || 0);
  const dateValue = (card) => Date.parse(card.getAttribute('data-review-date') || '') || 0;
  const indexValue = (card) => numberValue(card, 'data-review-index');

  function compareCards(mode, a, b) {
    if (mode === 'highest') {
      return (
        numberValue(b, 'data-review-rating') - numberValue(a, 'data-review-rating') ||
        dateValue(b) - dateValue(a) ||
        indexValue(a) - indexValue(b)
      );
    }

    if (mode === 'photos') {
      return (
        numberValue(b, 'data-review-photo') - numberValue(a, 'data-review-photo') ||
        dateValue(b) - dateValue(a) ||
        indexValue(a) - indexValue(b)
      );
    }

    return dateValue(b) - dateValue(a) || indexValue(a) - indexValue(b);
  }

  function addReadToggle(card) {
    const body = card.querySelector('.tf-rev-card__body');
    if (!body || body.textContent.trim().length < 190) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'tf-rev-card__read';
    button.setAttribute('data-review-read-toggle', '');
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'Read more';
    button.addEventListener('click', function () {
      const expanded = card.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? 'Read less' : 'Read more';
    });
    body.insertAdjacentElement('afterend', button);
  }

  function mergeCurrentReviews(feed, grid) {
    const cache = feed.querySelector('[data-live-review-cache]');
    if (!cache) return;
    const signature = (author, body) => (author.trim().toLowerCase() + '|' + body.replace(/\s+/g, ' ').trim());
    const known = new Set(Array.from(grid.querySelectorAll('[data-review-card]')).map(card =>
      signature(card.querySelector('.tf-rev-card__author')?.textContent || '', card.querySelector('.tf-rev-card__body')?.textContent || '')));
    cache.content.querySelectorAll('.jdgm-rev').forEach((review, index) => {
      const body = review.querySelector('.jdgm-rev__body')?.textContent.trim() || '';
      const author = review.querySelector('.jdgm-rev__author')?.textContent.trim() || 'Anonymous';
      const score = Number(review.querySelector('[data-score]')?.dataset.score);
      if (!body || score < 1 || score > 5 || known.has(signature(author, body))) return;
      known.add(signature(author, body));
      const date = (review.querySelector('time')?.getAttribute('datetime') || review.querySelector('[data-content]')?.dataset.content || '').slice(0, 10);
      const product = review.closest('[data-review-product]');
      const card = document.createElement('article');
      card.className = 'tf-rev-card';
      card.dataset.reviewCard = '';
      card.dataset.reviewDate = date;
      card.dataset.reviewRating = score;
      card.dataset.reviewIndex = index;
      card.dataset.reviewPhoto = '0';
      const add = (tag, cls, text, parent=card) => {
        const el = document.createElement(tag); el.className = cls; el.textContent = text; parent.append(el); return el;
      };
      const photoSource = review.querySelector('.jdgm-rev__pics img');
      const photoUrl = photoSource?.getAttribute('data-src') || photoSource?.getAttribute('src');
      if (photoUrl && photoUrl.startsWith('https://')) {
        const photo = add('img', 'tf-rev-card__photo', '');
        photo.src = photoUrl; photo.alt = 'Customer photo from ' + author; photo.loading = 'lazy'; photo.width = 480; photo.height = 480;
        card.dataset.reviewPhoto = '1';
      }
      const stars = add('div', 'tf-rev-card__stars', '★'.repeat(score) + '☆'.repeat(5-score));
      stars.setAttribute('aria-label', score + ' out of 5 stars');
      add('p', 'tf-rev-card__body', body);
      const meta = add('footer', 'tf-rev-card__meta', '');
      add('span', 'tf-rev-card__author', author, meta);
      if (review.dataset.verifiedBuyer === 'true') add('span', 'tf-rev-card__verified', 'Verified buyer', meta);
      const time = add('time', '', date, meta); time.dateTime = date;
      const url = review.dataset.productUrl || product?.dataset.reviewProductUrl || '';
      if (url.startsWith('/products/')) {
        const link = add('a', 'tf-rev-card__product', review.dataset.productTitle || product?.dataset.reviewProduct || 'View product', meta);
        link.href = url;
      }
      grid.append(card);
    });
  }

  function enhanceReviews() {
    const feed = document.querySelector('[data-review-feed]');
    if (!feed || feed.hasAttribute('data-review-enhanced')) return;

    const grid = feed.querySelector('[data-review-grid]');
    const sort = feed.querySelector('[data-review-sort]');
    const status = feed.querySelector('[data-review-status]');
    if (!grid || !sort || !status) return;

    mergeCurrentReviews(feed, grid);
    const cards = Array.from(grid.querySelectorAll('[data-review-card]'));
    cards.forEach(function (card) {
      card.removeAttribute('hidden');
      addReadToggle(card);
    });
    feed.setAttribute('data-review-enhanced', '');

    function orderCards(mode) {
      cards.sort(compareCards.bind(null, mode));
      cards.forEach(function (card) {
        grid.appendChild(card);
      });
      status.textContent = `Showing ${cards.length} recent and previously featured reviews.`;
    }

    feed.querySelector('[data-review-photos]')?.addEventListener('click', function () {
      sort.value = 'photos';
      orderCards('photos');
      grid.scrollIntoView({behavior: 'smooth', block:'start'});
    });
    sort.addEventListener('change', function () {
      orderCards(sort.value || 'newest');
    });
    orderCards(sort.value || 'newest');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceReviews, { once: true });
  } else {
    enhanceReviews();
  }
})();
